<template>
    <div>

        <div id="hello-hello">
            <p style="display:inline;float: left;line-height: 22px;"><b>租户列表</b></p>

            <p style="display:inline;float: right;line-height: 40px;margin:5px 0">
                <el-button round @click="permissionClick">导入权限</el-button>
            </p>
        </div>

        <el-table :data="tenantList" style="width: 100%" @select="selectClick" @row-click="rowClick" ref="tenantTable" highlight-current-row>
            <el-table-column type="selection" width="45" label-class-name="DisabledSelection">
            </el-table-column>
            
            <el-table-column type="index" width="40">
            </el-table-column>
            <el-table-column prop="companyName" label="租户" min-width="25%">
            </el-table-column>
            <el-table-column prop="username" label="用户" min-width="20%">
            </el-table-column>
            <el-table-column prop="phone" label="智模号" min-width="15%">
            </el-table-column>

            <el-table-column prop="createdTime" label="创建日期" min-width="15%">
            </el-table-column>

            <el-table-column prop="expireTime" label="有效期" min-width="15%">
                <template slot-scope="scope">
                    <el-tag size='mini' v-if="scope.row.etTag" type="danger">已过期</el-tag>
                    <span>{{ scope.row.expireTime }}</span>
                </template>
            </el-table-column>

            <el-table-column prop="status" label="状态" min-width="10%">
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="200">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="primary" round size="small">
                        编辑
                    </el-button>
                    <el-button @click="deleteClick(scope.row)" type="warning" round size="small">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <!-- <div>
            <el-pagination background :page-size="10" :page-count="pageCount" layout="prev, pager, next" :total="total"
                @current-change="pageClick" hide-on-single-page>
            </el-pagination>
        </div> -->

        <el-dialog title="租户详情" :visible.sync="dialogFormVisible" width="60%">
            <el-form :inline="true" :model="form" :rules="rules" ref="ruleForm">
                <el-form-item label="租户" required :label-width="formLabelWidth">
                    <el-input v-model="form.companyName" autocomplete="off" style="width:220px" disabled></el-input>
                </el-form-item>

                <el-form-item label="用户" required :label-width="formLabelWidth" prop="username">
                    <el-input v-model="form.username" autocomplete="off" style="width:220px" disabled></el-input>
                </el-form-item>

                <el-form-item label="智模号" required :label-width="formLabelWidth" prop="phone">
                    <el-input v-model="form.phone" autocomplete="off" style="width:220px" disabled></el-input>
                </el-form-item>

                <el-form-item label="创建日期" required :label-width="formLabelWidth" prop="createdTime">
                    <el-date-picker v-model="form.createdTime" type="date" placeholder="选择日期" disabled>
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="有效期" required :label-width="formLabelWidth" prop="expireTime">
                    <el-date-picker v-model="form.expireTime" type="date" placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <div style="width:350px;display: inline-block;"></div>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="$event => editCompany('ruleForm')">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "TenantAdmin",
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),
            tenantList: [],
            dialogFormVisible: false,
            
            form: {
                id: '',
                companyName: '大公司',
                username: '老板',
                phone: '18888888888',

                createdTime: new Date(),
                expireTime: '',
                status: 0
            },
            
            formLabelWidth: '120px',
            
            rules: {
                expireTime: [
                    { required: true, message: '请选择有效期', trigger: 'blur' },
                    { required: true, message: '请选择有效期', trigger: 'change' }
                ]
            },
            opCompanyId: ''
        }
    },
    methods: {
        selectClick(selection, row) {
            
            this.rowClick(row)
        },
        rowClick(row) {

            this.$refs.tenantTable.clearSelection()
            this.$refs.tenantTable.toggleRowSelection(row)

            this.opCompanyId = row.id
        },
        permissionClick() {

            if (this.opCompanyId == '') {
                this.$message({
                    type: 'info',
                    message: '请选择租户'
                })
                return
            }

            this.$axios({
                method: "post",
                url: "/shiro/role/permission/imp",
                data: {
                    companyId: this.opCompanyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status == 201) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                }

            })
        },
        handleClick(row) {
            
            this.form.id = row.id
            
            this.form.companyName = row.companyName
            this.form.username = row.username
            this.form.phone = row.phone

            this.form.createdTime = row.createdTime
            this.form.expireTime = row.expireTime
            this.form.status = null
            
            this.dialogFormVisible = true
        },
        deleteClick(row) {
            this.$confirm('确定要删除该租户吗？可能造成无法挽回的损失！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.removeCompany(row)

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });
            })
        },
        removeCompany(row) {
            this.$axios({
                method: "delete",
                url: "/shiro/company/remove",
                data: {
                    id: row.id
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data

                this.getAll()

            })
        },
        editCompany(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // alert('submit!');
                    this.$axios({
                        method: "post",
                        url: "/shiro/company/modify",
                        data: {
                            id: this.form.id,

                            expireTime: this.form.expireTime
                        }, headers: {
                            token: this.token
                        }
                    }).then(result => {

                        const data = result.data

                        this.$message(data.msg)

                        this.dialogFormVisible = false
                        this.getAll()
                    })
                } else {
                    // console.log('error submit!!');
                    return false
                }
            });

        },
        getAll(val) {

            const formData = new FormData()

            formData.append('id', this.companyId)
            // formData.append('pageIndex', this.pageIndex)
            // formData.append('pageNum', 10)

            this.$axios({
                method: "post",
                url: "/shiro/company/tenant",
                data: formData,
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status == 400 || data.status == 401) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    });
                    this.$router.push({ path: "/Login" })
                }

                this.tenantList = data.data
                // this.total = this.tenantList[0].total
                // this.pageCount = this.total % 10 == 0 ? this.total % 10 : this.total % 10 + 1

                for (let i in this.tenantList) {
                    this.tenantList[i].createdTime = this.$moment(this.tenantList[i].createdTime).format("YYYY-MM-DD")

                    var etStr = this.$moment(this.tenantList[i].expireTime).format("YYYY-MM-DD HH:mm")
                    var et = new Date(etStr)

                    if (et < new Date()) {
                        this.tenantList[i].etTag = true
                        this.tenantList[i].expireTime = ''
                    } else {
                        this.tenantList[i].expireTime = etStr
                    }

                    if (this.tenantList[i].status == 0) {
                        this.tenantList[i].status = '禁用'
                    } else if (this.tenantList[i].status == 1) {
                        this.tenantList[i].status = '启用'
                    }
                }
            })
        },
        pageClick(currentPage) {
            // console.log('pageClick()')
            // console.log(currentPage)
            this.pageIndex = (currentPage - 1) * 10
            this.getAll()
        }
    },
    mounted() {

        this.getAll()

        // this.getAllEmp()
    }
}
</script>

<style>
#order-header {
    height: 70px;
}

#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}
</style>